// extracted by mini-css-extract-plugin
export default {"container":"cardList_container__RriCc","spinner":"cardList_spinner__KU6zS","msg":"cardList_msg__ttoK-"};